export default "__VITE_ASSET__DLVGCQqV__"